import React, { Component } from "react";
import { connect } from "react-redux";
// import axios from "../../axios-services";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../store/actions/index";
import SimpleRating from "../UI/Rating/SimpleRating";
import SimpleGetRating from "../UI/Rating/SimpleGetRating";
import { getDateFromTime } from "../../store/utility";
import WriteReviewModal from "../UI/Modal/writeReviewModal";

class CompletedOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      review: "", 
      // rating:this.props.order.rating?this.props.order.rating:0,
      rating: null,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmitReview = this.handleSubmitReview.bind(this);
    this.handleRatingChange = this.handleRatingChange.bind(this);
  }

  handleChange(e) {
    let { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  }

  handleSubmitReview(e, order) {
    e.preventDefault();
    let review = this.state.review;
    let userId = this.props.userId;
    let rating = this.state.rating;
    this.props.onPostReview(userId, order, rating, review);
  }

  handleRatingChange(newRating) {
    this.setState({
      rating: newRating,
    });
  }

  render() {
    let order = this.props.order;
    return (
      <div
        className="card col-12 col-md-12 my-2 rounded"
        style={{ border: "1px solid rgba(0,0,0,.125)" }}
      >
        <div className="card-wrapper mt-2">
          <div className="top-line">
            <h6 className="card-title mbr-fonts-style display-7">
              <strong>
                {order.serviceName}{" "}
                <p className="mbr-text cost mbr-fonts-style display-7 float-right">
                  ₹ {order.totalPrice}
                </p>
              </strong>
            </h6>
            <p>Order Id: {order.receipt}</p>
            <p style={{ marginBottom: "0.5rem" }}>
              Services:{" "}
              {order.products.map((product, index) => (
                <span key={index}>{product.productName},</span>
              ))}
            </p>
          </div>
          <p>Date: {getDateFromTime(order.bookingDate)}</p>
          {/* 
        <p>Completed By: {order.professionalName}</p> */}

          {/* ----------------------- Write Review Modal starts ----------------------- */}
          <WriteReviewModal key={order.receipt} receipt={order.receipt}>
            <React.Fragment>
              <button className="btn btn-warning btn-sm mt-0">
                Write Review
              </button> 
            </React.Fragment>
            <React.Fragment>{order.receipt}</React.Fragment> 
            <div className="text-center">
              <form>
                <div style={{ margin: "auto", width: "55%" }}>
                  <SimpleGetRating
                    key={order.orderId}
                    handleRatingChange={this.handleRatingChange}
                  />
                </div>
                <textarea
                  className="form-control"
                  name="review"
                  id={`${order.receipt}`}
                  placeholder="Please write a review for us!"
                  rows="3"
                  onChange={this.handleChange}
                  value={this.state.review}
                  disabled={this.props.writeReviewLoading}
                  style={{ marginTop: "10px" }}
                  required
                ></textarea>
              </form>
            </div>
            <div style={{ display: "inline" }}>
              <button
                className="btn btn-success btn-sm"
                onClick={(e) => this.handleSubmitReview(e, order)}
                disabled={
                  this.state.rating === null || this.props.writeReviewLoading
                }
              >
                {this.props.writeReviewLoading ? "Saving" : "Submit"}
              </button>
            </div>
         
          </WriteReviewModal>
          {/* ----------------------- Write Review Modal ends ----------------------- */}
          <div className="bottom-line float-right" key={order.receipt}>
            <SimpleRating
              rating={order.rating}
              key={order.orderId}
              readOnly={"readOnly"}
              // onPostRating={()=>this.props.onPostReview(order.receipt,order.rating,null)}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    writeReviewLoading: state.review.writeReviewLoading,
    userId: state.auth.userId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onPostReview: (userId, orderId, rating, review) =>
      dispatch(actions.onPostReview(userId, orderId, rating, review)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompletedOrders);
